import { CognitoUserPool, AuthenticationDetails, CognitoUser } from "amazon-cognito-identity-js";
import ConfigResolver from '../../config/ConfigResolver';

const { IdentityPoolId, ClientId, UserPoolId, region} = ConfigResolver.config();

export default class LoginClass {
    completeNewPasswordChallenge = (password, requiredAttributes, cb) => {

        this.cognitoUser.completeNewPasswordChallenge(password, requiredAttributes, {
          onSuccess: () => cb.onSuccess(),
          onFailure: err => cb.onFailure(err)
        });
    }

    userAttr = (result, cb) => {
      this.cognitoUser.getUserAttributes((err, result) => {
        if (err) {
          return;
        }
        cb.onSuccess();
      });
    }

    authenticate = (username, password, cb) => {
        const authenticationData = {
          Username: username.toLowerCase(),
          Password: password,
        };

        const authenticationDetails = new AuthenticationDetails(authenticationData);
        const poolData = {
          ClientId: ClientId, // Your client id here
        	UserPoolId: UserPoolId, // Your user pool id here
        };

        const userPool = new CognitoUserPool(poolData);
        const userData = {
          Username: username,
          Pool: userPool
        };
        const cognitoUser = new CognitoUser(userData);
        this.cognitoUser = cognitoUser;
        cognitoUser.authenticateUser(authenticationDetails, {
          newPasswordRequired: (userAttributes) => cb.newPasswordRequired(),
          onSuccess: (response) => {
            return cb.onSuccess(response);
          },
          onFailure: (err) => cb.onFailure(err)
        });
    }
}



// WEBPACK FOOTER //
// ./src/shared/loginClass/LoginClass.jsx